<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <g clip-path="url(#clip0_6130_1882)">
      <path
        d="M19.7782 4.22202C20.2858 4.72966 20.2857 5.55253 19.7782 6.06022L13.8382 12.0002L19.7782 17.9402C20.2857 18.4478 20.2857 19.2707 19.7782 19.7784C19.2705 20.286 18.4477 20.2859 17.94 19.7784L12 13.8384L6.06003 19.7784C5.55233 20.2859 4.72946 20.286 4.22183 19.7784C3.71433 19.2707 3.71433 18.4478 4.22183 17.9402L10.1618 12.0002L4.22183 6.06022C3.71428 5.55253 3.71419 4.72966 4.22183 4.22202C4.72947 3.71452 5.55238 3.71452 6.06003 4.22202L12 10.162L17.94 4.22202C18.4476 3.71452 19.2705 3.71452 19.7782 4.22202Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_6130_1882">
        <rect width="24" height="24"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'IconApecClose',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
